import { render, staticRenderFns } from "./RegistrarSancion.vue?vue&type=template&id=7559d2ee"
import script from "./RegistrarSancion.vue?vue&type=script&lang=js"
export * from "./RegistrarSancion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports